import "@babel/polyfill";
import 'custom-event-polyfill';
var jQueryBridget = require("jquery-bridget");
var Flickity = require("flickity-fade");
var Header = document.querySelector("header");
var Blazy = require("blazy");
import Headroom from "headroom.js";

/* eslint-disable */

export default {
  init() {
    
    Flickity.setJQuery($);
    jQueryBridget("flickity", Flickity, $);
    var headroom  = new Headroom(Header);
    
    headroom.init();
    var bLazy = new Blazy();

    $(".open-button").click(function(e) {
      e.preventDefault();
      $(this).toggleClass("open");
      $(".nav-primary").toggleClass("open");
      $(".headroom").toggleClass("menu-open");
      $("html").toggleClass("scrolloff");
    });
    $(window).on("load", function() {
  
      var bLazy2 = new Blazy();
      
      tabletCheck();
      $(window).resize(tabletCheck);

      function tabletCheck() {
        if ($(window).width() > 1024) {
          var hero = $(".hero-slider").flickity({
            imagesLoaded: true,
            pageDots: false,
            cellAlign: "right",
            contain: true,
            autoPlay: true,
            prevNextButtons: false,
            wrapAround: true,
            fade: true,
            pauseAutoPlayOnHover: false,
            watchCss: true,
            setGallerySize: false,
          });
        }
      }

      var $carousel = $(".text-slider");

      $carousel.on( 'ready.flickity', function() {
        $('.text-slider').prepend('<div class="cover left"></div><div class="cover right"></div>');
        $(".cover.left").click(function() {
          $carousel.flickity( 'previous', true );
        });
        $(".cover.right").click(function() {
          $carousel.flickity( 'next', true );
        });
      });

      var $testimonials = $(".testimonial-slider");

      $testimonials.on( 'ready.flickity', function() {
        $('.testimonial-slider').prepend('<div class="cover left"></div><div class="cover right"></div>');
        $(".cover.left").click(function() {
          $testimonials.flickity( 'previous', true );
        });
        $(".cover.right").click(function() {
          $testimonials.flickity( 'next', true );
        });
      });

      var $quotes = $(".quotes-slider");

      $quotes.on( 'ready.flickity', function() {
        $('.quotes-slider').prepend('<div class="cover left"></div><div class="cover right"></div>');
        $(".cover.left").click(function() {
          $quotes.flickity( 'previous', true );
        });
        $(".cover.right").click(function() {
          $quotes.flickity( 'next', true );
        });
      });

      $testimonials.flickity({
        pageDots: true,
        cellAlign: "left",
        contain: true,
        autoPlay: 3000,
        prevNextButtons: false,
        wrapAround: false,
        fade: true,
        pauseAutoPlayOnHover: true,
      });

      $quotes.flickity({
        pageDots: true,
        cellAlign: "left",
        contain: true,
        autoPlay: 3000,
        prevNextButtons: false,
        wrapAround: false,
        fade: true,
        pauseAutoPlayOnHover: true,
      });

      $carousel.flickity({
        pageDots: true,
        cellAlign: "left",
        contain: true,
        autoPlay: 3000,
        prevNextButtons: false,
        wrapAround: false,
        fade: true,
        pauseAutoPlayOnHover: true,
      });

      $('.nav-primary .menu-item-has-children').append('<a class="expander"></a>')

      $(".expander").click(function() {
        $(this).siblings('.sub-menu').toggleClass("expand");
        $(this).toggleClass("open");
      });
        

    });

    $(".hero.hero-section, .project-header").click(function() {
      var height = $(".hero").height();
      var completeCalled = false;
      $("html, body").animate({ scrollTop: height },
      {
          complete : function(){
              if(!completeCalled){
                  completeCalled = true;
              }
          }
      });  
    });

    $(".posts-load").click(function() {
      var $offset = $(this).attr("data-offset");
      var $type = $(this).attr("data-type");
      if($type=='testimonials'){
        var $excludelist = $(this).attr("data-exclude");
        var $exclude = $excludelist.split(",");
      } else {
        var $exclude = "0";
      }

      $('.loading').show();
      $.ajax({
        url: ajax_object.ajax_url,
        data: {
            action: 'get_ajax_posts',
            type: $type,
            offset: $offset,
            exclude: $exclude,
        },
        type: 'POST',
        success: function(response) {
            $('.posts').append(response)
            $('.loading').hide();
            bLazy.revalidate();
        },
      })
      $offset = parseInt($offset) + 6;
      $(this).attr("data-offset", $offset);
      
      var $width = $('.sbi_photo').width();
      $('.sbi_photo').css('height', $width);

    });

    

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js